import React, { useEffect, useState } from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "../EmployeeSection/transactionlist.css";
import Base from "../admin_components/Admin_Base";
import { Breadcrumbs } from "@mui/material";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import authAxios from "../Auth/useAxios";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import Swal from "sweetalert2";
import { ClipLoader } from "react-spinners";

const EmployeeTransactionIncentiveList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 33;
  const [filterStatus, setFilterStatus] = useState("all");
  const [incentivelist, setIncentiveList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);



  useEffect(() => {
    fetchEmployeeIncentiveList();
  }, []);

  const fetchEmployeeIncentiveList = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/customer-emi-incentives`
      );
      setIncentiveList(response.data)

      console.log("incentivelist", response.data)
    } catch (error) {
      console.error("❌ Login Error:", error.response?.data?.message || error);
    } finally {
      setLoading(false);
    }
  };
  const filteredTransactions = incentivelist.filter((transaction) =>
    filterStatus === "all"
      ? true
      : transaction.month.toLowerCase() === filterStatus
  );

  const totalPages = Math.ceil(filteredTransactions.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedTransactions = filteredTransactions.slice(
    startIndex,
    endIndex
  );

  const convertToCSV = (data) => {
    const headers = [
      "S.No",
      "Customer Name",
      "Passbook No",
      "EMI Month",
      "Amount Paid",
      "GM% Amount",
      "AGM% Amount",
      "DM% Amount",
      "DO% Amount",
      "MO% Amount",
    ];

    const rows = data.map((transaction) => [
      transaction.sno,
      transaction.customerName,
      transaction.passbookNo,
      transaction.emiMonth,
      transaction.amountPaid,
      transaction.gmAmount,
      transaction.agmAmount,
      transaction.dmAmount,
      transaction.doAmount,
      transaction.moAmount,
    ]);

    return [headers.join(","), ...rows.map((row) => row.join(","))].join("\n");
  };

  const handleDownload = () => {
    const csvData = convertToCSV(filteredTransactions);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "employee_transaction_incentives.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div className="pt-3 mt-5 addarea_labels pr-3">
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              <Link
                underline="hover"
                key="1"
                color="inherit"
                href="/admin/dashboard"
                sx={{ color: "darkslategrey", fontWeight: "bold" }}
              >
                Dashboard
              </Link>
              <Link
                underline="hover"
                key="3"
                color="inherit"
                href="/admin/admin_employee_transactions_incentiveslist"
                sx={{ color: "darkslategrey", fontWeight: "bold" }}
              >
                Employee Transactions Incentives List
              </Link>
            </Breadcrumbs>
          </div>

          <h2 className="text-center fw-bold main_heading">
            Employee Transactions Incentives List
          </h2>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "95%" }} />
          </div>

          {/* Filter Dropdown and Download Button */}
          <div className="d-flex justify-content-start mb-3 align-items-center">
            <div style={{ marginRight: "15px" }}>
              <label htmlFor="status-filter" style={{ marginRight: "5px" }}>
                Filter by Month:
              </label>
              <select
                id="status-filter"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <option value="all">All</option>
                <option value="January">January</option>
                <option value="February">February</option>
                <option value="April">April</option>
                <option value="May">May</option>
                <option value="June">June</option>
                <option value="July">July</option>
                <option value="August">August</option>
                <option value="September">September</option>
                <option value="October">October</option>
                <option value="November">November</option>
                <option value="December">December</option>
              </select>
            </div>

            <button
              className="btn-employee-transactionlist"
              onClick={handleDownload}
            >
              Download CSV
            </button>
          </div>

          <div className="employee-transaction-container">
            <Table className="responsive-table customer-table">
              <Thead>
                <Tr>
                  <Th>S.No</Th>
                  <Th>Customer Name</Th>
                  <Th>Passbook No</Th>
                  <Th>EMI Month</Th>
                  <Th>Amount Paid</Th>
                  <Th>GM% Amount</Th>
                  <Th>AGM% Amount</Th>
                  <Th>DM% Amount</Th>
                  <Th>DO% Amount</Th>
                  <Th>MO% Amount</Th>
                </Tr>
              </Thead>
              <Tbody>
                {paginatedTransactions.map((transaction, index) => (
                  <Tr key={transaction.sno}>
                    <Td>{index + 1}</Td>
                    <Td>{transaction.customerName}</Td>
                    <Td>{transaction.passbook}</Td>
                    <Td>{transaction.month}</Td>
                    <Td>{Math.round(transaction.emiAmount)}</Td>
                    <Td>{Math.round(transaction.gmAmount)}</Td>
                    <Td>{Math.round(transaction.agmAmount)}</Td>
                    <Td>{Math.round(transaction.dmAmount)}</Td>
                    <Td>{Math.round(transaction.doAmount)}</Td>
                    <Td>{Math.round(transaction.moAmount)}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>

            {/* Pagination Controls */}
            <div className="pagination-controls">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </>
      )}
    </Base>
  );
};

export default EmployeeTransactionIncentiveList;
